import { BaseModel } from './base/base.model';

export class TramosCodigoEmpleado extends BaseModel {
    trabajadorCodInicial: string;
    trabajadorCodFinal: string;
    profesionalCodInicial: string;
    profesionalCodFinal: string;
    comiteCodInicial: string;
    comiteCodFinal: string;
}
